import { memo } from 'react'

import css from './AppErrorState.module.scss'

import Button from '@/components/Button'
import Heading from '@/components/Heading'

export interface ViewProps {
  denied?: boolean
  onHome: () => void
  onRetry?: () => void
}

const View = memo(function AppErrorStateView({ denied = false, onHome, onRetry }: ViewProps) {
  return (
    <section className={`AppErrorState ${css.root}`} aria-label={denied ? 'Access denied' : 'Page error'}>
      <Heading as="h1">{denied ? 'Administrator access required' : 'This page could not be displayed'}</Heading>
      <p>
        {denied
          ? 'This page requires administrator privileges. Your account doesn’t have access. Contact an administrator if you need access.'
          : 'An unexpected error prevented this page from loading. Try loading it again. If the problem continues, share the page you were opening with the team.'}
      </p>
      <div className={css.actions}>
        {!denied && onRetry && <Button onClick={onRetry}>Try again</Button>}
        <Button variant="secondary" onClick={onHome}>
          Back to Home
        </Button>
      </div>
    </section>
  )
})

View.displayName = 'AppErrorState_View'
export default View
